import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { UsersPage } from "@/components/users/users-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/users",
  loader: async () => {
    const res = await fetch("/api/users?page=1&limit=20");
    const data = res.ok ? await res.json() : { users: [], total: 0 };
    return { users: data.users ?? [], total: data.total ?? 0 };
  },
  component: UsersPageGuard,
});

function UsersPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <UsersPage />;
}
